(function() {
  'use strict';

  var AUTOSCROLL_INTERVAL = 4000;
  var carouselIntervals = new Map();

  console.log('🎠 Carousel Auto-Scroll Script Loaded');

  function enableInfiniteLoop(carousel) {
    // Remove the 'disabled' attribute from slideshow to enable infinite mode
    carousel.setAttribute('infinite', '');
    carousel.removeAttribute('disabled');
    
    console.log('♾️ Infinite loop enabled on carousel');
  }

  function startCarouselAutoScroll(carousel) {
    console.log('🔄 Attempting to start carousel:', carousel);
    
    if (carouselIntervals.has(carousel)) {
      console.log('⚠️ Carousel already initialized, skipping');
      return;
    }

    // Enable infinite looping
    enableInfiniteLoop(carousel);

    var nextButton = carousel.querySelector(':scope > slideshow-container > slideshow-arrows > .slideshow-control--next');
    
    console.log('🔘 Next button found:', nextButton);
    
    if (!nextButton) {
      console.log('❌ No next button found, aborting');
      return;
    }

    // Remove disabled attribute from buttons to keep them always active
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'disabled') {
          if (nextButton.hasAttribute('disabled')) {
            console.log('🔓 Removing disabled from next button');
            nextButton.removeAttribute('disabled');
          }
        }
      });
    });

    observer.observe(nextButton, { attributes: true });

    var intervalId = setInterval(function() {
      console.log('➡️ Clicking next slide');
      nextButton.click();
    }, AUTOSCROLL_INTERVAL);

    carouselIntervals.set(carousel, intervalId);
    console.log('✅ Carousel auto-scroll started with interval:', intervalId);

    carousel.addEventListener('mouseenter', function() {
      console.log('⏸️ Mouse entered - pausing');
      var id = carouselIntervals.get(carousel);
      if (id) {
        clearInterval(id);
        carouselIntervals.delete(carousel);
      }
    });

    carousel.addEventListener('mouseleave', function() {
      console.log('▶️ Mouse left - resuming');
      if (!carouselIntervals.has(carousel)) {
        startCarouselAutoScroll(carousel);
      }
    });
  }

  function initAllCarousels() {
    console.log('🔍 Searching for carousels...');
    var carousels = document.querySelectorAll('slideshow-component.resource-list__carousel');
    console.log('📦 Found', carousels.length, 'carousels');
    
    carousels.forEach(function(carousel, index) {
      console.log('🎯 Initializing carousel #' + (index + 1));
      startCarouselAutoScroll(carousel);
    });
  }

  if (document.readyState === 'loading') {
    console.log('⏳ Document still loading, waiting for DOMContentLoaded...');
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    console.log('✨ Document already loaded, initializing now');
    initAllCarousels();
  }

  document.addEventListener('shopify:section:load', function() {
    console.log('🔄 Shopify section loaded, re-initializing');
    initAllCarousels();
  });
  
  setTimeout(function() {
    console.log('⏰ Backup initialization after 1 second');
    initAllCarousels();
  }, 1000);
})();